import { ref, computed } from 'vue';

// Module-level state so every useCurrentUser() call shares the same user.
// Starts null; populated by the login flow (immediately, from the login
// response) or by an explicit fetch (on page reload — see MainView).
const currentUser = ref(null);

export function useCurrentUser() {
  const username = computed(() => currentUser.value?.username || '');
  const roles = computed(() => currentUser.value?.roles || []);

  const hasRole = (role) => (currentUser.value?.roles || []).includes(role);

  // set/clear are called from LoginForm (after login) and useAuth.logout.
  // Kept dependency-free so this module can be imported anywhere without
  // pulling in api.js (which imports useAuth — would risk a cycle).
  const set = (user) => {
    currentUser.value = user;
  };

  const clear = () => {
    currentUser.value = null;
  };

  return {
    currentUser,
    username,
    roles,
    hasRole,
    set,
    clear,
  };
}
